<template>
    <div>
        <transfer-breadcrumbs :search-request="searchRequest" class="pa-5" />
    </div>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'
    import TransferBreadcrumbs from '@/components/transfers/TransferBreadcrumbs.vue'

    @Component({
        components: {TransferBreadcrumbs},
        setup() {
            const app = useNuxtApp()
            useHead({
                title: app.$i18n.t('compare_transfers'),
            })
        },
    })
    export class TransfersComparisonPage extends Vue {
        async mounted() {
            await this.$store.restored
        }

        get searchRequest() {
            return transfersStore.searchRequest
        }
    }

    export default TransfersComparisonPage
</script>
